import React, { useState } from 'react';
import { River } from '../images/River';
import { Alert } from '../images/Alert';
import { RightArrow } from '../images/RightArrow';
import { Notification } from '../images/Notification';
import FacilityCard from './FacilityCard';

const SearchResults = ({ results, searchTerm, onRiverClick, facilityData }) => {
  const [activeRiverId, setActiveRiverId] = useState(null);

  const handleRiverClick = (riverId, riverData) => {
    setActiveRiverId(riverId);
    onRiverClick(riverId); 
  };

  const handleBackClick = () => {
    setActiveRiverId(null);
    onRiverClick(null); 
  };
  
  // Find the active river data
  const activeRiver = results.find(r => r.type === 'river' && r.id === activeRiverId);

  const searchLower = searchTerm.toLowerCase();
  const filteredResults = results.filter(item => {
    if (item.type === 'river') {
      return (
        item.name?.toLowerCase().includes(searchLower) ||
        item.region_name?.toLowerCase().includes(searchLower)
      );
    }

    if (item.type === 'facility' && item.data) {
      return (
        item.data.region_name?.toLowerCase().includes(searchLower) ||
        item.data.river_name?.toLowerCase().includes(searchLower) ||
        item.data.near_town?.toLowerCase().includes(searchLower) ||
        item.data.facility_name?.toLowerCase().includes(searchLower)
      );
    }

    return false;
  });

  // Remove duplicates
  const uniqueResults = filteredResults.filter((item, index, self) =>
    index === self.findIndex(
      (r) => r.type === item.type && r.id === item.id
    )
  );

  // Sort results alphabetically by name
  const sortedResults = [...uniqueResults].sort((a, b) => {
    const nameA = a.name || a.data?.facility_name || '';
    const nameB = b.name || b.data?.facility_name || '';
    return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
  });

  return (
    <div className="search-results">
      {activeRiverId && activeRiver ? (
        <>
          <button
            className="river-back-button"
            onClick={handleBackClick}
          >
            <h1>{activeRiver.name}</h1>
          </button>
          {activeRiver.facilities && activeRiver.facilities.length > 0 ? (
            <div className="facility-list">
              {activeRiver.facilities.map((facility, facilityIndex) => (
                <FacilityCard
                  key={facility.facility_id || facilityIndex}
                  data={facility}
                />
              ))}
            </div>
          ) : (
            <h4>No facilities found in this river.</h4>
          )}
        </>
      ) : (
        <>
          <div className='title'>
            <h1>
              Search ({searchTerm})
            </h1>
          </div>
          {sortedResults.length > 0 ? (
            <div className="rivers-list">
              <ul className="list-unstyled">
                {sortedResults.map((result, index) => (
                  <li
                    key={`${result.type}-${result.id}-${index}`}
                    className={`search-result-item ${result.type}`}
                  >
                    {result.type === 'river' ? (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleRiverClick(result.id, result);
                        }}
                        className="river-result"
                      >
                        <div className="rivers-list-icon">
                          <div className="icon">
                            <River />
                            <div className="badge-label">
                              {Number(result.alert_count) > 0 && <Alert />}
                              {Number(result.notification_count) > 0 && <Notification />}
                            </div>
                          </div>

                          <div className="text">
                            <h4>{result.name}</h4>
                            <p>{result.facilities?.length || 0} facilities</p>
                          </div>
                        </div>

                        <div className="rivers-list-text-arrow">
                          <p>{result.facilities?.length || 0} facilities</p>
                          <div className="rivers-list-arrow">
                            <RightArrow />
                          </div>
                        </div>
                      </a>
                    ) : (
                      <div className="facility-result">
                        <FacilityCard data={result.data} />
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <h4>No results found for "{searchTerm}"</h4>
          )}
        </>
      )}
    </div>
  );
};

export default SearchResults;
